import React, { Component } from 'react';
import { Grid, Cell, List, ListItem, ListItemContent } from 'react-mdl';

export default class Contact extends Component {
  render() {
    return(
      <div className="contact-body">
        <Grid className="contact-grid">
          <Cell col={6}>
            <h2>nicols Co</h2>
            <img
              src="https://raw.githubusercontent.com/nkhrulev/data/master/img/portfolio/portfolio.png"
              alt="avatar"
              style={{height: '250px'}}
               />
             <p style={{ width: '75%', margin: 'auto', paddingTop: '1em'}}></p>
          </Cell>

          <Cell col={6}>
            <h2>Contact Me</h2>
            <hr  style={{borderTop: '3px solid #833fb2', width: '50%'}} />

            <div className="contact-list">
              <List>
                <ListItem>
                  <ListItemContent style={{fontSize: '3vh', fontFamily: 'Lato'}}>
                    <i className="fa fa-phone-square" aria-hidden="true"/>
                     8 (917) 573-20-52
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize: '3vh', fontFamily: 'Lato'}}>
                    <i className="fa fa-envelope-square" aria-hidden="true"/>
                    <a href='mailto:hru91nik@mail.ru'>hru91nik@mail.ru</a>
                  </ListItemContent>
                </ListItem>

                <ListItem>
                  <ListItemContent style={{fontSize: '3vh', fontFamily: 'Lato'}}>
                    <i className="fa fa-skype" aria-hidden="true"/>
                    <a href="callto://+79175732052">n.khrulev</a>
                  </ListItemContent>
                </ListItem>
              </List>
            </div>
          </Cell>
        </Grid>
      </div>
    )
  }
}